import WebLayout from './OrderingWrapper.web';
import MobileLayout from './OrderingWrapper.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
